module.exports = __webpack_public_path__ + "img/icon_map_7_off_101.f071f9e0.png";